/*
 * Copyright (c) 2017.  Spin in het Web BV Apeldoorn
 * Geen toestemming zonder gebruik zonder schriftelijke overeenkomst
 * Ook bij schriftelijke overeenkomst is het gebruik van deze code
 * beperkt tot de in de overeenkomst opgenomen voorwaarden.
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 3-8-2016
 * Time: 13:51
 * VERSIE: 20180206-01
 *
 */

angular.module('SpinJS2', ['sihw.angular.config', 'sihw.sihwlog'])
    .provider('spinJS2', function SpinJS2Provider() {
        /* Private props */
        var url = null; //socket.io url als https://localhost:3332/v2, zie url
        var socket = null; //wordt gezet in init van de service
        var auth = {
            storekey: 'spinjs2', //onder welke key wordt er opgeslagen
            persistence: 'memory',
            store: {} //wordt in configuratie eventueel op sessie of local gezet. Voor memory is het gewoon een geheugen object
        };


        //beschikbaar als provider tijdens configuratiefase
        var provider = {
            /**
             * Zet de socket.io verbindingsstring op de meegegeven url
             * @param in_Url
             * @return this
             */
            url: function (in_Url) {
                url = in_Url;
                return this;
            },
            /**
             * @deprecated Gebruik sihwAngularConfigProvider.loglevel(level,'spinJS2')
             *
             */
            setDebug() {
                console.warn("spinJS2Provider.setDebug is deprecated en no-op. Gebruik config sihwAngularConfigProvider.loglevel(level,'spinJS2')");
                return this;
            },
            /**
             * Set de opslag van de eventuele auth-informatie
             * @param {('memory'|'session'|'storage')} persistence
             * @return {provider} chaining
             */
            authPersistence: function (persistence) {
                if (['memory', 'session', 'storage'].indexOf(persistence) === -1) {
                    console.warn('spinJS2Provider.authPersistence, ongeldige persistence "' + persistence + '". We gebruiken memory');
                    persistence = 'memory';
                }
                auth.persistence = persistence;
                //we zetten nu de store goed
                switch (persistence) {
                    case 'memory':
                        auth.store = {}; //een geheugenobject
                        break;
                    case 'session':
                        auth.store = window.sessionStorage || {}; //sessiestorage, met fallback
                        break;
                    case 'storage':
                        auth.store = window.localStorage || window.sessionStorage || {}; //localstorage, met fallback
                        break;
                }
                return this;
            },
            /**
             * Set een versiestring voor opslag van auth-informatie
             * @param versionstring
             * @return {provider} chaining
             */
            authVersion: function (versionstring) {
                //we maken er meteen een key van
                auth.storekey = "auth_" + versionstring;
                return this;
            }
        };

        //SERVICE
        provider.$get = ['$q', '$rootScope', '$timeout', 'sihwAngularConfig', 'sihwlog',
            function ($q, $rootScope, $timeout, sihwAngularConfig, sihwlog) {
                let log = sihwlog.logLevel(sihwAngularConfig.loglevel('spinJS2'));
                log.info(`Spinjs2 client angular module (c) 2016 Jellybean BV / Spin in het Web BV`);
                log.info(`URL: ${url}`);

                var whenConnectedPromises = []; //promises die resolven zodra de verbinding met het backend er is
                var service = {
                    /**
                     * Initialiseer de spinjs-service
                     */
                    init: function () {
                        socket = io.connect(url);
                        socket.on('connect', function () {
                            log.debug('SpinJS2: connect', {url: url});
                            $rootScope.$broadcast('SpinJS2.connect');
                            $rootScope.$broadcast('SpinJS2.connectChanged');
                            $rootScope.$digest();
                            _resolveWhenConnected();
                        });
                        socket.on('reconnect', function () {
                            log.debug('SpinJS2: reconnect');
                            $rootScope.$broadcast('SpinJS2.reconnect');
                            $rootScope.$broadcast('SpinJS2.connectChanged');
                            $rootScope.$digest();
                            _resolveWhenConnected();
                        });
                        socket.on('error', function () {
                            log.warn('SpinJS2: error', arguments);
                            //we geven het door aan geïnteresseerden
                            $rootScope.$broadcast('SpinJS2.error', arguments);
                            $rootScope.$broadcast('SpinJS2.connectChanged');
                            $rootScope.$digest();
                        });
                        socket.on('reconnect_failed', function () {
                            log.warn('SpinJS2: error', arguments);
                            //we geven het door aan geïnteresseerden
                            $rootScope.$broadcast('SpinJS2.error', arguments);
                            $rootScope.$broadcast('SpinJS2.connectChanged');
                            $rootScope.$digest();
                        });
                        socket.on('disconnect', function () {
                            log.debug('SpinJS2: close', arguments);
                            $rootScope.$broadcast(('SpinJS2.close'));
                            $rootScope.$broadcast('SpinJS2.connectChanged');
                            $rootScope.$digest();
                        });

                        //notificatie door het backend
                        socket.on('notify', function (notifydata) {
                            //stuur het de wereld in:
                            log.debug('SpinJS2: notify', notifydata);
                            $rootScope.$broadcast('api.notify.' + notifydata.msg, notifydata.data);
                            $rootScope.$apply(); //want extern event
                        });

                        log.debug('spinJS2 init compleet.');
                    },

                    /**
                     * @deprecated Gebruik sihwAngularConfigProvider.loglevel(level,'spinJS2')
                     * @param bDebug
                     */
                    setDebug(bDebug) {
                        log.warn("spinJS2.setDebug is deprecated en no-op. Gebruik config sihwAngularConfigProvider.loglevel(level,'spinJS2')");
                        return this;
                    },


                    /**
                     * Stel een nieuwe authkey in voor gebruik vanaf nu. Deze key wordt ook opgeslagen als de SpinJS2Provider.authPersistence is gezet op 'session' of 'storage'
                     * @param authkey
                     * @return {service} chaining
                     */
                    setAuth: function (authkey) {
                        _saveAuth(authkey);
                        return this;
                    },
                    /**
                     * Verwijder de authkey die gebruikt wordt. Vanaf nu gaan backendcalls zonder authkey. De key wordt ook verwijderd uit de ingestelde persistent storage
                     * @return {service}
                     */
                    deleteAuth: function () {
                        _deleteAuth();
                        return this;
                    },

                    /**
                     * Geeft terug of er een authkey geregistreerd is (zegt niets over of die klopt)
                     * @return {boolean}
                     */
                    hasAuth: function () {
                        return !!_getAuth();
                    },

                    get authKey() {
                        return _getAuth();
                    },


                    /**
                     * Return de huidige url
                     * @return {*}
                     */
                    getUrl: function () {
                        return url;
                    },

                    /**
                     * Maak een complete get-url met de gegeven argumenten en eventueel een authkey
                     * @param controller
                     * @param actie
                     * @param args Argumentenarray, voeg eventueel een extra arg toe om een mooie titel in een browserscherm te krijgen
                     * @param metAuth
                     */
                    maakGetUrl: function (controller, actie, args, metAuth) {
                        let volUrl = url;
                        if (volUrl[volUrl.length - 1] !== '/') {
                            volUrl += '/';
                        }
                        volUrl += `${controller}/${actie}`;
                        if (metAuth) {
                            volUrl += '/' + encodeURIComponent(`a=${_getAuth() || ''}`);
                        }
                        volUrl += args.map(arg => `/${encodeURIComponent(arg)}`).join('');
                        return volUrl;
                    },

                    /**
                     * Doe een ping-request volgens het spinjs-protocol. Return de promise die dus zal resolven of rejecten
                     */
                    ping: function () {
                        return this.send('spinjs2', 'ping');
                    },

                    /**
                     * Geef een promise die resolvet als we verbinding (her)krijgen met het backend
                     * @return {*}
                     */
                    whenConnected: function () {
                        if (this.connected()) {
                            return $q.resolve(true); //meteen al klaar, want we zijn nu verbonden
                        }
                        log.debug('whenConnected geeft promise terug die nog niet resolved is');
                        var deferred = $q.defer();
                        whenConnectedPromises.push(deferred); //kan straks resolven
                        return deferred.promise; //de promise
                    },
                    /**
                     * Afhandelen communicatie met het SpinJS2 backend
                     * @param ctrl
                     * @param action
                     * @param {object} [data]
                     * @param {bool} [noapply] Als true, dan wordt er geen apply gedaan
                     * @return {*} promise
                     */
                    send: function (ctrl, action, data, noapply) {
                        var $this = this;
                        data = data || {};

                        //speciaal: als data._spinjs2_slowdebug een waarde heeft, dan is dat een timeout voor deze send
                        //om slome lijnen te testen

                        if (data._spinjs2_slowdebug) {
                            var vertraging = data._spinjs2_slowdebug;
                            delete data._spinjs2_slowdebug;
                            console.warn("SPINJS2 SLOW DEBUG: send met vertraging", vertraging, arguments);
                            //we wachten even met zenden, alsof het sloom is
                            return $q(function (resolve, reject) {
                                $timeout(function () {
                                    $this.send(ctrl, action, data, noapply).then(resolve, reject);
                                }, vertraging, false);
                            });
                        }

                        var deferred = $q.defer();
                        var promise = deferred.promise;
                        var emitstate = 'init'; //we houden het een en ander bij

                        //zet een timeout op de verzending. Wat we daarmee doen hangt af van de verbindingsstatus
                        let timeout = 20000; //als we nu verbonden zijn, kijken we pas over lange tijd of alles goed is. Wel kan het zijn dat de verbinding al weg is, maar de socket dat nog niet weet (verbindingsprobleem aan client-kant)
                        if (!socket.connected) {
                            //sneller checken
                            log.info('SPINJS2: socket nog niet verbonden tijdens send. We sturen het bericht, maar deze kan dus een timeout geven');
                            timeout = 10000; //genoeg voor hobbeltjes
                        }

                        let timoutHandler = function () {
                            //al klaar?
                            if (emitstate === "antwoord") {
                                return; //we zijn klaar
                            }
                            log.debug(`Check send timeout ${socket.connected ? "connected" : "disconnected"} Emitstate: ${emitstate}`);
                            //als we niet connected zijn, geven we een timeout, dan is het gewoon kansloos
                            if (!socket.connected) {
                                emitstate = "skip"; //mocht het ooit nog komen
                                log.warn('SPINJS2: Timeout connecting');
                                deferred.reject('timeout connecting');
                            } else {
                                //wel verbonden, nog geen antwoord. Gewoon straks weer proberen
                                $timeout(timoutHandler, 30000, false);
                            }
                        };
                        $timeout(timoutHandler, timeout, false); //maximaal

                        log.debug("SpinJS2: SEND => " + ctrl + "." + action, data, _getAuth() ? 'auth' : 'noauth');
                        socket.emit('apireq',
                            {
                                controller: ctrl,
                                action: action,
                                auth: _getAuth(),
                                data: data
                            },
                            function (resultaat, rdata) {
                                if (emitstate === "skip") {
                                    return; //promise als rejected door de timeout
                                }
                                emitstate = 'antwoord'; //we hebben antwoord
                                //gelukt of mislukt
                                log.debug('SpinJS2: RESULTAAT <= ' + ctrl + '.' + action, resultaat, rdata);
                                if (!resultaat) {
                                    deferred.reject(rdata);
                                    //we breken in de gewone cycle in, zeker tijdens unit-testing
                                    //anders wordt de .then tijdens unit-tests nooit gerund
                                    if (!noapply) {
                                        $rootScope.$apply();
                                    }
                                } else {
                                    //nieuwe authkey teruggekregen?
                                    try {
                                        if (rdata._newauth) {
                                            //alleen als we er al eentje hadden
                                            if (_getAuth()) {
                                                log.debug('SPINJS2 we hebben een nieuw auth');
                                                _saveAuth(rdata._newauth); //dit is de nieuwe
                                                delete rdata._newauth;
                                            } else {
                                                log.warn('SPINJS2 we krijgen een nieuwe auth, maar hadden er geen');
                                            }
                                        }
                                    } catch (_e) {
                                        //blijkbaar is rdata geen object? Whatever
                                        log.debug('SPINJS2 reply kon niet gecheckt worden op _newauth');
                                    }
                                    deferred.resolve(rdata);
                                    //we breken in de gewone cycle in, zeker tijdens unit-testing
                                    //anders wordt de .then tijdens unit-tests nooit gerund
                                    if (!noapply) {
                                        $rootScope.$apply();
                                    }
                                }
                            }
                        );
                        emitstate = 'verzonden'; //wacht op antwoord
                        return promise;
                    },

                    getScope: function () {
                        return $rootScope;
                    },

                    /**
                     * Zijn we op dit moment verbonden?
                     * @return {boolean}
                     */
                    connected: function () {
                        return socket && socket.connected;
                    }
                };

                //private functies
                /**
                 * Haal de huidige authkey op, of false als die er niet is
                 * De key wordt gehaald uit de storage zoals in configuratie is gezet met authPersistence
                 * @return {*|boolean}
                 */
                function _getAuth() {
                    return auth.store[auth.storekey] || false;
                }

                /**
                 * Sla een authkey op voor gebruik
                 * @param authkey
                 */
                function _saveAuth(authkey) {
                    auth.store[auth.storekey] = authkey;
                }

                function _deleteAuth() {
                    delete auth.store[auth.storekey];
                }

                /**
                 * Helper bij whenConnected: resolve alle promises op het moment dat er verbinding is
                 * @private
                 */
                function _resolveWhenConnected() {
                    whenConnectedPromises.forEach(function (p) {
                        log.debug('whenConnected: promise resolvet nu');
                        p.resolve()
                    });
                    whenConnectedPromises = [];
                }

                //initialiseer
                service.init();
                return service;
            }];
        return provider;
    });
